import styled from 'styled-components';
import UIFullScreen from 'UIComponents/dialog/UIFullScreen';
import OutsideClickListener from '../OutsideClickListener';
import { rgba } from 'foundations-components/transitional/utils/color';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const Overlay = styled.div.withConfig({
  displayName: "EPFullscreenOverlay__Overlay",
  componentId: "sc-17aeboh-0"
})(({
  theme
}) => {
  return {
    backgroundColor: rgba(theme.color['fill-accent-neutral-default'], 0.25),
    bottom: 0,
    left: 0,
    position: 'fixed',
    contain: 'content',
    overflow: 'auto',
    right: 0,
    top: 0,
    zIndex: 1111
  };
});
const StyledOverlay = ({
  children,
  width
}) => {
  return /*#__PURE__*/_jsx(Overlay, {
    children: /*#__PURE__*/_jsx(View, {
      maxInlineSize: width,
      marginBlock: "0",
      marginInline: "auto",
      blockSize: "100%",
      children: children
    })
  });
};
const EPFullscreenOverlay = ({
  children,
  onClose
}) => {
  return /*#__PURE__*/_jsx(UIFullScreen, {
    children: /*#__PURE__*/_jsx(StyledOverlay, {
      width: "580px",
      children: /*#__PURE__*/_jsx(Flex, {
        position: "absolute",
        inset: "0",
        insetBlockStart: "1500",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(OutsideClickListener, {
          onOutsideClick: onClose,
          children: children
        })
      })
    })
  });
};
export default EPFullscreenOverlay;